import { useMemo } from 'react';
import { useScreenSize } from '@/hooks/useScreenSize';

interface UseResponsiveDimentionsOptions {
  defaultWidth: number;
  defaultHeight: number;
  breakpoint?: number;
  padding?: number;
  desiredRatio?: number;
}

export const useResponsiveDimentions = ({
  defaultWidth,
  defaultHeight,
  desiredRatio = undefined,
  breakpoint = 768,
  padding = 64,
}: UseResponsiveDimentionsOptions) => {
  const { width: screenWidth } = useScreenSize();

  return useMemo(() => {
    const ratio = desiredRatio ?? defaultHeight / defaultWidth;

    if (screenWidth > breakpoint) {
      return {
        width: defaultWidth,
        height: defaultHeight,
      };
    }

    const width = screenWidth - padding;
    const height = width * ratio;

    return {
      width,
      height,
    };
  }, [screenWidth, defaultWidth, defaultHeight, breakpoint, padding]);
};
